module.exports = __webpack_public_path__ + "static/img-29969c2f4d2917b678555cd1d83b6ef7.png";